import { render, staticRenderFns } from "./Generic_CollapsedExtents.vue?vue&type=template&id=22024fc7&scoped=true&"
import script from "./Generic_CollapsedExtents.vue?vue&type=script&lang=js&"
export * from "./Generic_CollapsedExtents.vue?vue&type=script&lang=js&"
import style0 from "./Generic_CollapsedExtents.vue?vue&type=style&index=0&id=22024fc7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22024fc7",
  null
  
)

export default component.exports